import { lazy } from 'react';
import { retry } from '@/utils/helpers/common';

// Organization pages
export const OrganizationCreatePage = lazy(
  () =>
    retry(() => import('@pages/administrative/accounts/organizations/create')) as Promise<
      typeof import('@pages/administrative/accounts/organizations/create')
    >
);

export const OrganizationListPage = lazy(
  () =>
    retry(() => import('@pages/administrative/accounts/organizations/list')) as Promise<
      typeof import('@pages/administrative/accounts/organizations/list')
    >
);

export const OrganizationEditPage = lazy(
  () =>
    retry(() => import('@pages/administrative/accounts/organizations/edit')) as Promise<
      typeof import('@pages/administrative/accounts/organizations/edit')
    >
);

export const OrganizationTabsPage = lazy(
  () =>
    retry(() => import('@pages/administrative/accounts/organizations/tabs')) as Promise<
      typeof import('@pages/administrative/accounts/organizations/tabs')
    >
);

export const OrganizationInformationEditPage = lazy(
  () =>
    retry(() => import('@pages/administrative/accounts/organizations/information-edit')) as Promise<
      typeof import('@pages/administrative/accounts/organizations/information-edit')
    >
);

export const LegalEntityCreatePage = lazy(
  () =>
    retry(() => import('@/pages/setting/legal-entities/create')) as Promise<
      typeof import('@/pages/setting/legal-entities/create')
    >
);

export const LegalEntityEditPage = lazy(
  () =>
    retry(() => import('@/pages/setting/legal-entities/edit')) as Promise<
      typeof import('@/pages/setting/legal-entities/edit')
    >
);

// Organization domain pages
export const OrganizationDomainCreatePage = lazy(
  () =>
    retry(
      () => import('@pages/administrative/accounts/organizations/domain/domain-create')
    ) as Promise<typeof import('@pages/administrative/accounts/organizations/domain/domain-create')>
);

export const OrganizationDomainEditPage = lazy(
  () =>
    retry(
      () => import('@pages/administrative/accounts/organizations/domain/domain-edit')
    ) as Promise<typeof import('@pages/administrative/accounts/organizations/domain/domain-edit')>
);

// Organization order pages
export const OrganizationOrderCreateView = lazy(
  () =>
    retry(
      () => import('@pages/administrative/accounts/organizations/order/order-create')
    ) as Promise<typeof import('@pages/administrative/accounts/organizations/order/order-create')>
);

export const OrganizationOrderEditPage = lazy(
  () =>
    retry(() => import('@pages/administrative/accounts/organizations/order/order-edit')) as Promise<
      typeof import('@pages/administrative/accounts/organizations/order/order-edit')
    >
);

// Contact pages
export const ContactListPage = lazy(
  () =>
    retry(() => import('@pages/administrative/accounts/contacts/list-page')) as Promise<
      typeof import('@pages/administrative/accounts/contacts/list-page')
    >
);

export const ContactCreatePage = lazy(
  () =>
    retry(() => import('@pages/administrative/accounts/contacts/create-page')) as Promise<
      typeof import('@pages/administrative/accounts/contacts/create-page')
    >
);

export const ContactEditPage = lazy(
  () =>
    retry(() => import('@pages/administrative/accounts/contacts/edit-page')) as Promise<
      typeof import('@pages/administrative/accounts/contacts/edit-page')
    >
);

// Organization contact pages
export const OrganizationContactCreatePage = lazy(
  () =>
    retry(
      () => import('@pages/administrative/accounts/organizations/contact/contact-create')
    ) as Promise<
      typeof import('@pages/administrative/accounts/organizations/contact/contact-create')
    >
);

export const OrganizationContactEditPage = lazy(
  () =>
    retry(
      () => import('@pages/administrative/accounts/organizations/contact/contact-edit')
    ) as Promise<typeof import('@pages/administrative/accounts/organizations/contact/contact-edit')>
);

// Organization user pages
export const OrganizationUserEditPage = lazy(
  () =>
    retry(() => import('@pages/administrative/accounts/organizations/users/user-edit')) as Promise<
      typeof import('@pages/administrative/accounts/organizations/users/user-edit')
    >
);

export const OrganizationUserCreatePage = lazy(
  () =>
    retry(
      () => import('@pages/administrative/accounts/organizations/users/user-create')
    ) as Promise<typeof import('@pages/administrative/accounts/organizations/users/user-create')>
);

// Subscription pages
export const SubscriptionListPage = lazy(
  () =>
    retry(() => import('@pages/administrative/accounts/subscriptions/list')) as Promise<
      typeof import('@pages/administrative/accounts/subscriptions/list')
    >
);

export const SubscriptionCreatePage = lazy(
  () =>
    retry(() => import('@pages/administrative/accounts/subscriptions/create')) as Promise<
      typeof import('@pages/administrative/accounts/subscriptions/create')
    >
);

export const SubscriptionEditPage = lazy(
  () =>
    retry(() => import('@pages/administrative/accounts/subscriptions/edit')) as Promise<
      typeof import('@pages/administrative/accounts/subscriptions/edit')
    >
);

export const OrganizationSubscriptionCreatePage = lazy(
  () =>
    retry(
      () => import('@pages/administrative/accounts/organizations/subscription/subscription-create')
    ) as Promise<
      typeof import('@pages/administrative/accounts/organizations/subscription/subscription-create')
    >
);

export const OrganizationSubscriptionEditPage = lazy(
  () =>
    retry(
      () => import('@pages/administrative/accounts/organizations/subscription/subscription-edit')
    ) as Promise<
      typeof import('@pages/administrative/accounts/organizations/subscription/subscription-edit')
    >
);

export const SubscriptionInformationPage = lazy(
  () =>
    retry(() => import('@pages/administrative/accounts/subscriptions/information')) as Promise<
      typeof import('@pages/administrative/accounts/subscriptions/information')
    >
);

export const SubscriptionOrderPage = lazy(
  () =>
    retry(() => import('@pages/administrative/accounts/subscriptions/orders')) as Promise<
      typeof import('@pages/administrative/accounts/subscriptions/orders')
    >
);

export const SubscriptionAddOnsPage = lazy(
  () =>
    retry(() => import('@pages/administrative/accounts/subscriptions/addons')) as Promise<
      typeof import('@pages/administrative/accounts/subscriptions/addons')
    >
);

export const SubscriptionAddOnsCreatePage = lazy(
  () =>
    retry(() => import('@pages/administrative/accounts/subscriptions/addons-create')) as Promise<
      typeof import('@pages/administrative/accounts/subscriptions/addons-create')
    >
);

export const SubscriptionAddOnsEditPage = lazy(
  () =>
    retry(() => import('@pages/administrative/accounts/subscriptions/addons-edit')) as Promise<
      typeof import('@pages/administrative/accounts/subscriptions/addons-edit')
    >
);

export const AddOnsTabPage = lazy(
  () =>
    retry(() => import('@pages/administrative/accounts/subscriptions/addons-tab')) as Promise<
      typeof import('@pages/administrative/accounts/subscriptions/addons-tab')
    >
);

export const SubscriptionAddOnsInformationView = lazy(
  () =>
    retry(
      () => import('@pages/administrative/accounts/subscriptions/addons-information')
    ) as Promise<typeof import('@pages/administrative/accounts/subscriptions/addons-information')>
);

export const OrganizationSubscriptionInformationPage = lazy(
  () =>
    retry(
      () =>
        import('@pages/administrative/accounts/organizations/subscription/subscription-information')
    ) as Promise<
      typeof import('@pages/administrative/accounts/organizations/subscription/subscription-information')
    >
);

export const OrganizationSubscriptionOrderPage = lazy(
  () =>
    retry(
      () => import('@pages/administrative/accounts/organizations/subscription/subscription-orders')
    ) as Promise<
      typeof import('@pages/administrative/accounts/organizations/subscription/subscription-orders')
    >
);

export const OrganizationSubscriptionBillingPage = lazy(
  () =>
    retry(
      () => import('@pages/administrative/accounts/organizations/subscription/subscription-billing')
    ) as Promise<
      typeof import('@pages/administrative/accounts/organizations/subscription/subscription-billing')
    >
);

export const OrganizationSubscriptionAddonsPage = lazy(
  () =>
    retry(
      () => import('@pages/administrative/accounts/organizations/subscription/subscription-addons')
    ) as Promise<
      typeof import('@pages/administrative/accounts/organizations/subscription/subscription-addons')
    >
);

export const OrganizationSubscriptionAddonsCreatePage = lazy(
  () =>
    retry(
      () =>
        import(
          '@pages/administrative/accounts/organizations/subscription/subscription-addons-create'
        )
    ) as Promise<
      typeof import('@pages/administrative/accounts/organizations/subscription/subscription-addons-create')
    >
);

export const OrganizationSubscriptionAddonsEditPage = lazy(
  () =>
    retry(
      () =>
        import('@pages/administrative/accounts/organizations/subscription/subscription-addons-edit')
    ) as Promise<
      typeof import('@pages/administrative/accounts/organizations/subscription/subscription-addons-edit')
    >
);

// Order pages
export const OrderListPage = lazy(
  () =>
    retry(() => import('@pages/administrative/accounts/orders/list')) as Promise<
      typeof import('@pages/administrative/accounts/orders/list')
    >
);

export const OrderEditPage = lazy(
  () =>
    retry(() => import('@pages/administrative/accounts/orders/edit')) as Promise<
      typeof import('@pages/administrative/accounts/orders/edit')
    >
);

export const OrderCreatePage = lazy(
  () =>
    retry(() => import('@pages/administrative/accounts/orders/create')) as Promise<
      typeof import('@pages/administrative/accounts/orders/create')
    >
);
// Organization Billing Order pages

export const OrganizationBillingOrderNewPage = lazy(
  () =>
    retry(
      () =>
        import(
          '@/sections/administrative/accounts/organizations/views/tabs/orders/billing-order-new'
        )
    ) as Promise<
      typeof import('@/sections/administrative/accounts/organizations/views/tabs/orders/billing-order-new')
    >
);

export const OrganizationBillingOrderInformationPage = lazy(
  () =>
    retry(
      () =>
        import(
          '@/sections/administrative/accounts/organizations/views/tabs/orders/billing-order-information'
        )
    ) as Promise<
      typeof import('@/sections/administrative/accounts/organizations/views/tabs/orders/billing-order-information')
    >
);

// Organization document pages
export const OrganizationDocumentEditPage = lazy(
  () =>
    retry(
      () => import('@pages/administrative/accounts/organizations/document/document-edit')
    ) as Promise<
      typeof import('@pages/administrative/accounts/organizations/document/document-edit')
    >
);

export const OrganizationDocumentCreatePage = lazy(
  () =>
    retry(
      () => import('@pages/administrative/accounts/organizations/document/document-create')
    ) as Promise<
      typeof import('@pages/administrative/accounts/organizations/document/document-create')
    >
);

// Request pages
export const RequestListPage = lazy(
  () =>
    retry(() => import('@pages/administrative/accounts/requests/list')) as Promise<
      typeof import('@pages/administrative/accounts/requests/list')
    >
);

export const RequestEditPage = lazy(
  () =>
    retry(() => import('@pages/administrative/accounts/requests/edit')) as Promise<
      typeof import('@pages/administrative/accounts/requests/edit')
    >
);

export const RequestCreatePage = lazy(
  () =>
    retry(() => import('@pages/administrative/accounts/requests/create')) as Promise<
      typeof import('@pages/administrative/accounts/requests/create')
    >
);

export const RequestUserListView = lazy(
  () =>
    retry(() => import('@pages/administrative/accounts/requests/users/list')) as Promise<
      typeof import('@pages/administrative/accounts/requests/users/list')
    >
);

export const RequestUserDetailView = lazy(
  () =>
    retry(() => import('@pages/administrative/accounts/requests/users/detail')) as Promise<
      typeof import('@pages/administrative/accounts/requests/users/detail')
    >
);

// Consumption bag pages
export const OrganizationConsumptionBagPage = lazy(
  () =>
    retry(
      () => import('@pages/administrative/accounts/organizations/consumption-bags/detail')
    ) as Promise<
      typeof import('@pages/administrative/accounts/organizations/consumption-bags/detail')
    >
);

// Cancellation order detail page
export const CancellationOrderDetailPage = lazy(() =>
  import('@/sections/administrative/accounts/orders/cancellation-order-detail').then((mod) => ({
    default: mod.CancellationOrderDetail,
  }))
);
